import React, { useEffect } from 'react';
import {
    FiXCircle,
    FiInfo,
    FiCheckCircle,
    FiAlertCircle,
    FiAlertTriangle,
} from 'react-icons/fi';

import { useToast } from '../../../hooks/toast';

import { Container } from './styles';

const icons = {
    info: <FiInfo size={20} />,
    success: <FiCheckCircle size={20} />,
    error: <FiAlertCircle size={20} />,
    warning: <FiAlertTriangle size={20} />,
};

const Toast = ({ message, style }) => {
    const { removeToast } = useToast();

    /*useEffect(() => {
        const timer = setTimeout(() => {
            removeToast(message.id);
        }, 3000000);

        return () => {
            clearTimeout(timer);
        };
    }, [removeToast, message.id]);*/

    return (
        <Container
            type={message.type}
            hasDescription={Number(!!message.description)}
            style={style}
        >
            {icons[message.type || 'info']}
            <div>
                <strong>{message.title || message.description || 'Notificação'}</strong>
                {message.description && message.title && (
                    <p>{message.description}</p>
                )}
            </div>

            <button type="button" onClick={() => removeToast(message.id)}>
                <FiXCircle size={18} />
            </button>
        </Container>
    );
};

export default Toast;
